
import { OAuth2Client } from '@kolorado/oauth';
import { AxiosResponse } from 'axios';
import { PreferredNetworkOtaspRequest } from '../entities/preferred-network-and-otasp-v1/preferred-network-otasp-request';
import { PreferredNetworkOtaspResponseBody } from '../entities/preferred-network-and-otasp-v1/preferred-network-otasp-response-body';
import { axiosInstance } from "../axios-instance";

class PreferredNetworkAndOTASPService {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  preferredNetworkCommandQueue = (
    input: PreferredNetworkOtaspRequest,
  ): Promise<AxiosResponse<PreferredNetworkOtaspResponseBody>> => {
    const accessToken = localStorage.getItem('accessToken');
    const authInfo: any = this.authClient?.authenticate();
    const userName = authInfo.loginId;
    const queryParameters = {
      ...input,
      userId: userName,
    };

    return axiosInstance.post(`${this.baseUrl}/queueCommands`, queryParameters, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  };
}

export default PreferredNetworkAndOTASPService;
